module.exports = __webpack_public_path__ + "img/ad_960x360.9c9f4e33.jpg";